import { useState } from 'react';

import { toastService } from '@thefarmersfront/kitchen-mobile';

import { useNavigateStore } from '../../store';
import { TOAST_MESSAGES } from '~/constants';

import { useCheckNetworkIP } from '../api/useCheckNetworkIP';
import { useCheckNetworkStatus } from '../bridge/useCheckNetworkStatus';

export const useValidNetwork = () => {
  const [isValid, setIsValid] = useState(false);

  const { setIsNavigateBlocking } = useNavigateStore((state) => state.actions);

  const { requestNetworkConnectivityByApp } = useCheckNetworkStatus();
  const requestCheckNetworkIP = useCheckNetworkIP();

  let errorMessage = '';

  /** 네트워크 연결이 되지 않았거나, 내부망이 아닌 경우 false 반환 */
  const checkValidNetwork = async (showError = true) => {
    let isValidNetwork = false;

    /** 1. 네트워크 연결 여부 확인 */
    const isNetworkConnected = await requestNetworkConnectivityByApp();

    /** 2. 연결된 네트워크가 내부망인지 확인 */
    if (isNetworkConnected) {
      await requestCheckNetworkIP({
        onSuccess: () => {
          errorMessage = '';
          isValidNetwork = true;
        },
        onError: (err) => {
          errorMessage = err.message;
          isValidNetwork = false;
        },
      });
    } else {
      errorMessage = TOAST_MESSAGES.INVALID_KURLYRO_NETWORK;
    }

    setIsValid(isValidNetwork);
    setIsNavigateBlocking(!isValidNetwork);

    if (!isValidNetwork && showError && errorMessage !== '') {
      showInvalidNetworkErrorToast();
    }
    return isValidNetwork;
  };

  const showInvalidNetworkErrorToast = () => {
    toastService.addToast({
      message: errorMessage,
      color: 'error',
    });
  };

  return {
    checkValidNetwork,
    isValidNetwork: isValid,
    showNetworkErrorToast: showInvalidNetworkErrorToast,
  };
};
